module.exports = __webpack_public_path__ + "static/1-8a324e487a75fc56e61abef1e645f193.jpg";